import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UserNotificationsComponent } from '../user-notifications/user-notifications.component';
import { UserProfileSettingsComponent } from '../user-profile-settings/user-profile-settings.component';

@Component({
  selector: 'rc-user-menu',
  standalone: true,
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
  imports: [TranslateModule, UserNotificationsComponent, UserProfileSettingsComponent],
})
export class UserMenuComponent {}
